export default "__VITE_ASSET__BZEI2YSc__"